export enum Flow {
  IM = 'IM',
  EX = 'EX',
}

export enum PaymentFlow {
  BEFORE = 'BEFORE',
  AFTER = 'AFTER',
}

export enum TypeOfUse {
  SINGLE = 'SINGLE',
  MULTIPLE = 'MULTIPLE',
}

export enum ValidityType {
  MANUAL = 'MANUAL',
  PERMANENT = 'PERMANENT',
  NUM_OF_DAYS = 'NUM_OF_DAYS',
}

export enum FeeMode {
  NONE = 'NONE',
  CALCULATED = 'CALCULATED',
  FIXED = 'FIXED',
}

export enum FeeType {
  APPLICATION_FEE = 'APPLICATION_FEE',
  EXTENSION_FEE = 'EXTENSION_FEE',
}

export enum Tab {
  HEADER = 'HEADER',
  NAMES_AND_PARTIES = 'NAMES_AND_PARTIES',
  CONSIGNMENT = 'CONSIGNMENT',
  BENEFICIARY = 'BENEFICIARY',
  ITEM = 'ITEM',
  FEES = 'FEES',
  ATTACHED_DOCUMENT = 'ATTACHED_DOCUMENT',
}

export enum DataType {
  CHECKBOX = 'CHECKBOX',
  DATE = 'DATE',
  INTEGER = 'INTEGER',
  DECIMAL = 'DECIMAL',
  MONETARY = 'MONETARY',
  QUANTITY = 'QUANTITY',
  TEXT = 'TEXT',
  TEXTAREA = 'TEXTAREA',
  LABEL = 'LABEL',
  LIST = 'LIST',
  OPTIONS_FROM_DATABASE = 'OPTIONS_FROM_DATABASE',
  SEPARATOR = 'SEPARATOR',
}

export enum QuotaType {
  UOM = 'UOM',
  VALUE = 'VALUE',
  NET_MASS = 'NET_MASS',
  GROSS_MASS = 'GROSS_MASS',
  UNLIMITED = 'UNLIMITED',
  TAX = 'TAX',
}

export enum Status {
  STORED = 'STORED',
  DELETED = 'DELETED',
  QUERIED = 'QUERIED',
  PENDING_PAYMENT = 'PENDING_PAYMENT',
  REQUESTED = 'REQUESTED',
  PARTIALLY_APPROVED = 'PARTIALLY_APPROVED',
  APPROVED = 'APPROVED',
  PARTIALLY_USED = 'PARTIALLY_USED',
  USED = 'USED',
  SUSPENDED = 'SUSPENDED',
  EXPIRED = 'EXPIRED',
  REJECTED = 'REJECTED',
  CANCELED = 'CANCELED',
  GENERATED = 'GENERATED',
  AMENDMENT_REQUESTED = 'AMENDMENT_REQUESTED',
}

export enum EntityName {
  LPCO = 'LPCO',
  ITEM = 'ITEM',
  ATTACHED_DOCUMENT = 'ATTACHED_DOCUMENT',
  BENEFICIARY = 'BENEFICIARY',
  FEE = 'FEE',
  ADDITIONAL_FIELD = 'ADDITIONAL_FIELD',
  ITEM_ADDITIONAL_FIELD = 'ITEM_ADDITIONAL_FIELD',
  ITEM_PACKAGE = 'ITEM_PACKAGE',
  ITEM_TREATMENT = 'ITEM_TREATMENT',
}

export enum RequestMethods {
  PUT = 'PUT',
  GET = 'GET',
  POST = 'POST',
  DELETE = 'DELETE',
}

export enum OperationType {
  STORE = 'STORE',
  UPDATE_STORE = 'UPDATE_STORE',
  REQUEST = 'REQUEST',
  SUBMIT_QUERIED = 'SUBMIT_QUERIED',
  UPDATE_QUERIED = 'UPDATE_QUERIED',
  DELETE = 'DELETE',
  CANCEL = 'CANCEL',
  CANCEL_APPROVED = 'CANCEL_APPROVED',
  CANCEL_PARTIALLY_APPROVED = 'CANCEL_PARTIALLY_APPROVED',
  REJECT = 'REJECT',
  QUERY = 'QUERY',
  RETURN = 'RETURN',
  SUSPEND = 'SUSPEND',
  ACTIVATE = 'ACTIVATE',
  OGA_UPDATE = 'OGA_UPDATE',
  UPDATE_APPROVED = 'UPDATE_APPROVED',
  EXTEND = 'EXTEND',
  REQUEST_EXTENSION = 'REQUEST_EXTENSION',
  MANUAL_PAYMENT = 'MANUAL_PAYMENT',
  EXPIRE = 'EXPIRE',
  UPDATE_BILL_NUMBER = 'UPDATE_BILL_NUMBER',
  REMOTE_PAY = 'REMOTE_PAY',
  APPROVE = 'APPROVE',
  REQUEST_AMENDMENT = 'REQUEST_AMENDMENT',
  REJECT_AMENDMENT = 'REJECT_AMENDMENT',
  APPROVE_AMENDMENT = 'APPROVE_AMENDMENT',
  // System operations
  USE = 'USE',
  PARTIALLY_USE = 'PARTIALLY_USE',
  CANCEL_USE = 'CANCEL_USE',
}

export enum FeatureFlag {
  flowEnabled = 'flowEnabled',
  relatedProductsEnabled = 'relatedProductsEnabled',
  listOfBeneficiariesEnabled = 'listOfBeneficiariesEnabled',
  suspendOpEnabled = 'suspendOpEnabled',
  cancelOpEnabled = 'cancelOpEnabled',
  updateApproveOpEnabled = 'updateApproveOpEnabled',
  packageManagementTableEnabled = 'packageManagementTableEnabled',
  treatmentTableEnabled = 'treatmentTableEnabled',
  extendBeforeExpirationEnabled = 'extendBeforeExpirationEnabled',
  extendAfterExpirationEnabled = 'extendAfterExpirationEnabled',
  packageManagementEnabled = 'packageManagementEnabled',
  invoiceValueManagementEnabled = 'invoiceValueManagementEnabled',
  itemWeightManagementEnabled = 'itemWeightManagementEnabled',
  editItemOnQueriedEnabled = 'editItemOnQueriedEnabled',
  editItemOnOgaEditEnabled = 'editItemOnOgaEditEnabled',
  requestedAndApprovedAmountEnabled = 'requestedAndApprovedAmountEnabled',
  remainingAmountEnabled = 'remainingAmountEnabled',
  showAmountToBePaidEnabled = 'showAmountToBePaidEnabled',
  riskExecutionForSubmitEnabled = 'riskExecutionForSubmitEnabled',
  riskExecutionForApproveEnabled = 'riskExecutionForApproveEnabled',
  printPreviewEnabled = 'printPreviewEnabled',
}

export enum RiskColor {
  NONE = 'NONE',
  GREEN = 'GREEN',
  BLUE = 'BLUE',
  YELLOW = 'YELLOW',
  ORANGE = 'ORANGE',
  RED = 'RED',
  PURPLE = 'PURPLE',
}
